export default {
  product: {
    title: 'Produto',
    selfCustodyWallet: 'Carteira móvel',
    selfCustodyWalletDesc: 'Carteira móvel cripto e Defi na Blockchain.',
    hardwareWallet: 'Carteira Hardware',
    hardwareWalletDesc: 'Obtém a tua KeyPal, para guardar os teus activos.',
    extensionWallet: 'Extensão de carteira',
    extensionWalletDesc: 'Uma carteira melhor no teu computador.',
    transit: 'Transit',
    transitDesc: 'Agregador de DEX Multi-cadeira e mercado de NFT.',
    fiveDegrees: '5Degrees',
    fiveDegreesDesc: 'Protocolo de Rede Social em Web3.0.',
    stakeVault: 'ETH Staking Vault',
    stakeVaultDesc:
      'Suporta tanto o staking de auto-custódia como o staking de pequenas quantidades',
  },
  project: {
    subToken: 'Submeter Token',
    subDApp: 'Submeter DApp',
    subNFT: 'Submeter NFT',
    subChain: 'Submeter Chain',
  },
  assets: {
    title: 'Activos',
  },
  collaborations: {
    title: 'Colaborações',
  },
  community: {
    title: 'Comunidade',
    developers: 'Programadores',
    recruiting: 'Homem TP',
  },
  helpCenter: {
    title: 'Ajuda',
  },
  features: {
    title: 'características',
    buyCrypto: 'Comprar cripto',
    mobileWallet: 'Carteira móve',
    hardwareWallet: 'Carteira de Hardware',
    extensionWallet: 'Extensão da Carteira',
    desktop: 'Carteira Desktop',
    fiveDegrees: '5Degrees',
    versionVerification: 'Version Verification',
    approvalDetector: 'Detector de Aprovação',
    tokenSecurity: 'Segurança do Token',
    keyGenerator: 'Gerador de Chaves',
    BATCH_SENDER: 'BatchSender',
  },
  information: {
    title: 'Informação',
    blockchainGuide: 'Guia da Blockchain',
    tronWallet: 'Guia TRON',
    iostWallet: 'Guia IOST',
    tpMan: 'Homem TP',
  },
  developers: {
    title: 'Programadores',
    github: 'Github (TP-Lab)',
    devCenter: 'Centro de Programadores',
    subToken: 'Submeter Token',
    subDApp: 'Submeter DApp',
    subNFT: 'Submeter NFT',
  },
  company: {
    title: 'Companhia',
    about: 'Acerca (de)',
    careers: 'Carreiras',
    pressKit: 'Kit de Imprensa',
    swagShop: 'Loja Swag',
  },
  support: {
    title: 'Suporte',
    helpCenter: 'Centro de Ajuda',
    contactUs: 'Contacta-nos',
  },
  legal: {
    title: 'Legal',
    privacyPolicy: 'Política de Privacidade',
    terms: 'Termos de Utilização',
  },
  main: {
    title: 'Verificação de Versão',
    language: 'Português',
    intro:
      'A verificação de versão é realizada por meio da correspondência dos valores de hash MD5 ou SHA256 entre as versões. Certifique-se de baixar a carteira TokenPocket por meio de canais oficiais para evitar ser enganado. Para instruções sobre como obter os valores de hash MD5 ou SHA256 de uma versão, por favor ',
    tutorial: 'consulte o tutorial >',
    system: 'Sistema Operacional',
    android: 'Android',
    ios: 'iOS',
    version: 'Versão',
    allVersion: 'Todas',
    appChannel: 'Canal do Aplicativo',
    developer: 'desenvolvedor',
    allChannel: 'Todos',
    md5: 'MD5',
    sha256: 'SHA256',
    log: 'Registro de Versão',
    check: 'Detalhes',
    versionLog: 'Registro de Versão',
    confirm: 'Confirmar',
    aboutIOS: 'Sobre a Versão iOS',
    IOSDesc:
      'Para versões do iOS, oferecemos nosso aplicativo apenas na App Store. Somente aplicativos baixados pela App Store podem ser instalados corretamente. Portanto, ao usar dispositivos Apple, certifique-se de autenticar a App Store como o único canal de download.',
    IOSDesc_2:
      'O desenvolvedor da versão baixada da App Store antes de 8 de outubro de 2022 é a TOKENPOCKET FOUNDATION LTD, que é uma versão anterior desenvolvida pela TokenPocket. É uma carteira legítima que pode ser usada normalmente, mas o serviço de atualização será temporariamente suspenso.',
    aboutAndroid: 'Sobre a Versão do Android',
    androidDesc: 'As opções de download do TokenPocket para Android incluem atualmente o site oficial, Google Play Store, Samsung App Store, Huawei AppGallery, OPPO App Store e Vivo App Store. Em algumas lojas de aplicativos, não é possível obter o arquivo de instalação APK durante o processo de download, portanto, não é possível realizar a verificação MD5 ou SHA256. Portanto, ao fazer o download, verifique claramente as informações do desenvolvedor, consultando abaixo!',
    IOSAppName: 'Nome do Aplicativo:',
    TPWallet: 'TP Wallet',
    AppIcon: 'Ícone do Aplicativo:',
    AppDeveloper: 'Desenvolvedor:',
    downloadLink: 'URL de Download:',
    copied: 'Copiado!',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'Siga-nos',
    desc1: 'TokenPocket Os funcionários não enviarão mensagens privadas!',
    desc2:
      'uidado! Você está entrando na comunidade TokenPocket, pode haver alguém se passando por nós para lhe enviar mensagens privadas! Esteja ciente de que qualquer pessoa que envie mensagens privadas pode ser um golpista! Nós nunca entraremos em contato com você primeiro!',
    desc3: 'Entendido, digite',
  },
};
